import api from './axios';

export const contactAPI = {
  /** GET /api/contact-settings (public) */
  get: () => api.get('/contact-settings'),
};
